/**
 * @module cover-modes
 *
 * @author michael.schmid@notch-interactive.com
 *
 * @description This module is to manage the different masonry instances
 */

/* Imports */
import imageGallery from './image-gallery';
import pubsub from '../libs/pubsub';

const instance = {},
    defaults = {
        baguetteBoxContainer: '.m-image-gallery',
        masonryContainer: '.grid',
        masonryColumnWidth: '.grid-sizer',
        masonryItemSelector: '.grid-item',
        boundAttr: 'data-gallery-bound'
    },
    imageGalleries = [],
    settings = {};

/**
 * Add new image gallery
 *
 * @param {object} options of the coverMode
 * @return {number} index of the new instance
 */

instance.init = (options) => {

    Object.assign(settings, defaults, options);

    const containers = document.querySelectorAll(settings.baguetteBoxContainer + ':not([' + settings.boundAttr + '])');

    containers.forEach((el) => {
        imageGalleries.push(imageGallery(el, Object.assign({}, settings)));
    });

    // Refresh masonry layouts when an overlay opened
    pubsub.on('overlay.opened', instance.refreshAll);
};

instance.refreshAll = () => {
    imageGalleries.forEach((gallery) => {
        gallery.refresh();
    });
};

export default instance;

// export forms object to window
window.DS = window.DS || {};
window.DS.imageGalleries = {
    refreshAll: instance.refreshAll
};
